import { map, prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { processBarChart } from '../slices/financial/financial-barchart';
import { processPieChart } from '../slices/financial/financial-piechart';
import { processFinancialFooter } from './financial/financial-footer';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicFinancialKeyFigures
 */

/**
 * @typedef {DocumentSchema} FinancialKeyFiguresSchema
 */

const processKeyFigures = (data = []) =>
  compact(
    map((entry) =>
      compact({
        title: prop('title', entry),
        subtitle: prop('subtitle', entry),
        text: prop('text', entry),
      })
    )(data)
  );

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialKeyFigures} data
 * @return {FinancialKeyFiguresSchema}
 */
const processFinancialKeyFigures = (data) =>
  compact({
    uid: DocumentType.FINANCIAL_KEY_FIGURES,
    type: DocumentType.FINANCIAL_KEY_FIGURES,
    ...processFinancialFooter(data),
    revenueFigure: processBarChart(prop('revenue_figure', data)),
    humanCapital: processPieChart(prop('human_capital', data)),
    financialResults: processBarChart(prop('financial_results', data)),
    financialStructure: processBarChart(prop('financial_structure', data)),
    environment: processKeyFigures(prop('environment', data)),
    society: processKeyFigures(prop('society', data)),
    filters: {
      [FILTER.MENU]: MENU.STATISTICS,
    },
  });

/**
 * Normalizr schema representing a financial key figures page
 */
export const FinancialKeyFigures = deprecatedPageEntity(
  DocumentType.FINANCIAL_KEY_FIGURES,
  {
    processStrategy: (entity) => ({
      ...processFinancialKeyFigures(prop('data', entity)),
    }),
  }
);
